import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageComponent } from 'src/app/core';

@Component({
  selector: 'app-auto-registration-top-bar',
  standalone: true,
  imports: [CommonModule, TranslateModule, LanguageComponent],
  templateUrl: './auto-registration-top-bar.component.html',
  styleUrl: './auto-registration-top-bar.component.scss',
})
export class AutoRegistrationTopBarComponent {
  @Input() logoSrc = 'assets/img/glameraTradeMarkLogo2.png';
  @Input() logoAlt = 'Glamera';
  @Input() logoWidth = 160;
  @Input() mobileLogoWidth = 120;
  @Input() languageColor?: string = '#000';
  @Input() showLogo = true;
  @Input() showActions = true;
  @Input() darkMode = false;

  @Output() watchVideo = new EventEmitter<void>();

  onWatchVideo(): void {
    this.watchVideo.emit();
  }
}
